import * as Yup from 'yup'
import {
  maxDigitsValidation,
  maxLengthValidation
} from '../utils/MaxLengthValidation'

const isItemSelectedForPayment = item => item?.checked === true

const visitFields = {
  // visitDate: Yup.date().required('Visit Date is required'),
  patientName: Yup.string().required('Patient Name is required'),
  patientType: Yup.string().trim().required('Patient Type is required'),
  practitioner: Yup.string().trim().required('Practitioner is required'),
  // payerName: Yup.string()
  //   .trim()
  //   .when('patientType', {
  //     is: 'insurance',
  //     then: () => Yup.string().trim().required('Payer is required'),
  //     otherwise: () => Yup.string().trim().notRequired()
  //   }),
  payerName: Yup.string().trim().required('Payer is required'),
  comment: Yup.string().trim().concat(maxLengthValidation(500)),
  speciality: Yup.string().trim().required('Speciality is required'),
  visitType: Yup.string().trim().required('Visit Type is required'),
  paymentMethod: Yup.string().trim().required('Payment Method is required'),
  paid: Yup.string()
}

const itemFields = {
  unit_price: Yup.number()
    .typeError('Price must be a number')
    .concat(maxDigitsValidation(10))
    .required('Unit Price is required'),
  quantity: Yup.number()
    .typeError('Quantity be a number')
    .concat(maxDigitsValidation(10))
    .required('Quantity is required'),
  patient_share: Yup.number()
    .typeError('Patient Share be a number')
    .concat(maxDigitsValidation(10))
    .required('Patient Share is required'),
  discount_amount: Yup.number()
    .typeError('Discount Amount be a number')
    .concat(maxDigitsValidation(10))
    .required('Discount Amount is required')
}

const buildVisitValidationSchema = ({
  validateOnlySelectedItems = false
} = {}) =>
  Yup.object({
    ...visitFields,
    items: Yup.array().of(
      validateOnlySelectedItems
        ? Yup.lazy(item =>
            isItemSelectedForPayment(item)
              ? Yup.object().shape(itemFields)
              : Yup.object()
          )
        : Yup.object().shape(itemFields)
    )
  })

// Every item is validated. Used by CreateVisitForm, CreateVisitWithoutSlot,
// EditClaimForm and by pay bill in the tabbed (category_tabs) display mode.
export const createVisitValidationSchema = buildVisitValidationSchema()

// Pay bill in the "all_items" display mode only: one sheet with a checkbox per
// row, so items the user has not selected must not raise errors.
export const createPayBillAllItemsValidationSchema = buildVisitValidationSchema({
  validateOnlySelectedItems: true
})
